import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "vote-form-page__footer" }
const _hoisted_2 = { class: "vote-form-page__footer-wrapper" }
const _hoisted_3 = { class: "vote-form-page__error-content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("strong", null, "Te már korábban szavaztál.", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Módosítom ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" További szavazások ")
const _hoisted_7 = { class: "vote-form-page__error-content" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("strong", null, " Hiba történt az autentikáció során, kérjük lépj be újra. ", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Belépés ")
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Következő ")
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("strong", null, " Hiba történt a szavazás mentése közben, próbáld újra. ", -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Elküldöm ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Az „elküldöm” gomb megnyomásával elfogadom a ")
const _hoisted_16 = ["href"]
const _hoisted_17 = { key: 2 }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Befejezem ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vote_form = _resolveComponent("vote-form")!
  const _component_cta_button = _resolveComponent("cta-button")!
  const _component_error = _resolveComponent("error")!
  const _component_arrow_right = _resolveComponent("arrow-right")!
  const _component_text_content = _resolveComponent("text-content")!
  const _component_transition_style = _resolveComponent("transition-style")!
  const _component_container = _resolveComponent("container")!
  const _component_page = _resolveComponent("page")!
  const _directive_visible = _resolveDirective("visible")!

  return (_ctx.user && _ctx.vote && _ctx.vote.isRunning)
    ? (_openBlock(), _createBlock(_component_page, {
        key: 0,
        is: "section",
        class: "vote-form-page"
      }, {
        default: _withCtx(() => [
          _createElementVNode("form", {
            onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.formSubmit && _ctx.formSubmit(...args)), ["prevent"])),
            class: "vote-form-page__form"
          }, [
            _createVNode(_component_vote_form, {
              vote: _ctx.vote,
              "persisted-data": _ctx.persistedData,
              modelValue: _ctx.formData,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData) = $event)),
              questionIndex: _ctx.questionIndex,
              "onUpdate:questionIndex": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.questionIndex) = $event)),
              selectedSubjectsData: _ctx.selectedSubjects,
              "onUpdate:selectedSubjectsData": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedSubjects) = $event)),
              class: "vote-form-page__content",
              readonly: _ctx.readonly || _ctx.voteSubmitter.loading,
              ref: "form"
            }, null, 8, ["vote", "persisted-data", "modelValue", "questionIndex", "selectedSubjectsData", "readonly"]),
            _createElementVNode("footer", _hoisted_1, [
              _createVNode(_component_transition_style, { name: "slide-up" }, {
                default: _withCtx(() => [
                  _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_container, null, {
                      default: _withCtx(() => [
                        (_ctx.readonly)
                          ? (_openBlock(), _createBlock(_component_error, {
                              key: 0,
                              closable: _ctx.vote.form.modifiable,
                              onClose: _ctx.unlock
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_3, [
                                  _hoisted_4,
                                  (_ctx.vote.form.modifiable)
                                    ? (_openBlock(), _createBlock(_component_cta_button, {
                                        key: 0,
                                        class: "vote-form-page__modify",
                                        theme: "primary",
                                        size: "normal",
                                        type: "button",
                                        onClick: _ctx.unlock
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_5
                                        ]),
                                        _: 1
                                      }, 8, ["onClick"]))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_cta_button, {
                                    theme: "primary",
                                    size: "small",
                                    to: { name: 'vote-list' }
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_6
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _: 1
                            }, 8, ["closable", "onClose"]))
                          : (_ctx.hasAuthError)
                            ? (_openBlock(), _createBlock(_component_error, {
                                key: 1,
                                closable: false
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_7, [
                                    _hoisted_8,
                                    _createVNode(_component_cta_button, {
                                      theme: "primary",
                                      size: "small",
                                      to: { name: 'vote-login' }
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_9
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_component_transition_style, {
                                key: 2,
                                mode: "out-in",
                                name: "fade"
                              }, {
                                default: _withCtx(() => [
                                  (
                    _ctx.questionIndex < _ctx.vote.form.questions.length - 1 &&
                    (!_ctx.vote.form.batchable ||
                      (_ctx.hasPersistedData(_ctx.questionIndex) &&
                        !_ctx.hasSelection(_ctx.questionIndex)))
                  )
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                        _createVNode(_component_cta_button, {
                                          type: "button",
                                          theme: "primary",
                                          block: "",
                                          onClick: _cache[3] || (_cache[3] = () => _ctx.questionIndex++)
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_11,
                                            _createVNode(_component_arrow_right)
                                          ]),
                                          _: 1
                                        })
                                      ]))
                                    : (
                    !_ctx.vote.form.batchable ||
                    (_ctx.hasSelection(_ctx.questionIndex) && _ctx.hasFormData)
                  )
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                          (_ctx.voteSubmitter.error)
                                            ? (_openBlock(), _createBlock(_component_error, {
                                                key: 0,
                                                class: "vote-form-page__error"
                                              }, {
                                                default: _withCtx(() => [
                                                  _hoisted_13
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true),
                                          _createVNode(_component_cta_button, {
                                            type: "submit",
                                            theme: "primary",
                                            block: "",
                                            loading: _ctx.voteSubmitter.loading
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_14,
                                              _createVNode(_component_arrow_right)
                                            ]),
                                            _: 1
                                          }, 8, ["loading"]),
                                          (_ctx.vote.form.terms)
                                            ? (_openBlock(), _createBlock(_component_text_content, {
                                                key: 1,
                                                class: "vote-form-page__terms"
                                              }, {
                                                default: _withCtx(() => [
                                                  _hoisted_15,
                                                  _createElementVNode("a", {
                                                    href: _ctx.vote.form.terms,
                                                    target: "_blank"
                                                  }, " felhasználási feltételeket ", 8, _hoisted_16)
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                          _createVNode(_component_cta_button, {
                                            type: "button",
                                            theme: "primary",
                                            block: "",
                                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goToEnd()))
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_18,
                                              _createVNode(_component_arrow_right)
                                            ]),
                                            _: 1
                                          })
                                        ]))
                                ]),
                                _: 1
                              }))
                      ]),
                      _: 1
                    })
                  ])), [
                    [_directive_visible, 
              _ctx.formIsValid(_ctx.questionIndex) &&
              (!_ctx.hasSelection(_ctx.questionIndex) || _ctx.hasSelectionData(_ctx.questionIndex))
            ]
                  ])
                ]),
                _: 1
              })
            ])
          ], 32)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}